import ReactDOM from 'react-dom';

import type { ReactNode } from 'react';

const portalRoot = typeof document !== 'undefined' ? document.getElementById('portal') : null;
const el = typeof document !== 'undefined' ? document.createElement('div') : null;

const Portal = ({ children }: { children: ReactNode; }) => {
  if (el && portalRoot) {
    return ReactDOM.createPortal(children, portalRoot);
  }

  return null;
};

export default Portal;
